import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
    const [user, setUser] = useState(null); // null=checking, false=guest, {}=user
    const [token, setToken] = useState(() => localStorage.getItem("kgd_token") || "");

    useEffect(() => {
        let mounted = true;
        (async () => {
            try {
                const headers = token ? { Authorization: `Bearer ${token}` } : {};
                const { data } = await api.get("/auth/me", { headers });
                if (mounted) setUser(data.user);
            } catch {
                if (mounted) setUser(false);
            }
        })();
        return () => { mounted = false; };
    }, [token]);

    const login = async (email, password) => {
        const { data } = await api.post("/auth/login", { email, password });
        setUser(data.user);
        if (data.token) {
            localStorage.setItem("kgd_token", data.token);
            setToken(data.token);
        }
        return data;
    };

    const logout = async () => {
        try { await api.post("/auth/logout"); } catch {}
        localStorage.removeItem("kgd_token");
        setToken("");
        setUser(false);
    };

    const authHeaders = token ? { Authorization: `Bearer ${token}` } : {};

    return (
        <AuthContext.Provider value={{ user, token, login, logout, authHeaders }}>
            {children}
        </AuthContext.Provider>
    );
}

export const useAuth = () => useContext(AuthContext);
